const metodeBayar = [
    {
        title: "M-Coin",
        subtitle: "Saldo saat ini",
        id: "1",
    },
    // Di matikan! nunggu pemberitahuan berikutnya
    // {
    //     title: "Transfer Bank",
    //     subtitle: "Transfer ke rekening Bank BCA / Mandiri",
    //     id: "2",
    // },
];

export default metodeBayar;
